
import { defineComponent, onMounted, reactive, computed } from "vue";
import mAxiosApi from "@/api";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

import ActivitesTickets from "@/views/still/deploy/activitesTickets.vue";
import SyntheseProjet from "@/views/still/deploy/syntheseProjet.vue";
import StockRefs from "./stockRefs.vue";

export default defineComponent({
  name: "customer-details",
  components: {
    ActivitesTickets,
    SyntheseProjet,
    StockRefs,
  },
  setup() {

    const router = useRouter();
    const store = useStore();
    const isReadOnly = computed(
      () => store.getters.currentUser.con_role_web === "Utilisateur (read-only)"
    );

    const affEquipByType = (type) => {
      router.push({  name: "listEquipementbyType", params: { code: type } });
    }

    const state = reactive({
      loaderEnabled: true,
    });
    const { t } = useI18n()

    const Plur = (item) => {
      if (item>0) return t('s');
    }

    onMounted(async () => {
      state.loaderEnabled = false;
    });

    return {
      state,
      isReadOnly,
      affEquipByType,
      Plur,
      model: {}
    };
  },
});
